import React, { useRef, useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Chart from 'react-apexcharts';
import classnames from 'classnames';
import dateFormat from 'dateformat';
import NumberFormat from 'react-number-format';
import { Select as Select$1 } from 'antd';

const Graph = ({ className, type, options, series, height, width }) => /* @__PURE__ */ React.createElement("div", {
  className
}, /* @__PURE__ */ React.createElement(Chart, {
  type,
  width,
  height,
  series,
  options
}));

const Status = ({ label, value, className }) => {
  let itemClss = classnames("secondColl", className, {
    "red": value == 0,
    "green": value == 1,
    "orange": value == 2
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: itemClss
  }, label);
};

const DateRange = ({ start, end, className, barClass, format }) => {
  let progressBarClss = classnames("progressBar", className);
  let barClss = classnames("bar", barClass);
  const getPercentage = () => {
    const today = new Date();
    if (today < start) {
      return "0%";
    } else {
      const spent = Math.round(
        (today.getTime() - start.getTime()) / (1e3 * 60 * 60 * 24)
      );
      const total = Math.round(
        (end.getTime() - start.getTime()) / (1e3 * 60 * 60 * 24) + 1
      );
      return `${spent / total * 100}%`;
    }
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: progressBarClss
  }, /* @__PURE__ */ React.createElement("div", {
    className: barClss,
    style: { width: getPercentage() }
  }), /* @__PURE__ */ React.createElement("p", null, dateFormat(start, format)), /* @__PURE__ */ React.createElement("p", null, dateFormat(end, format)));
};

const DetailCol = ({ text, className, icon, hasAction, onClick }) => {
  let itemClss = classnames(className);
  return /* @__PURE__ */ React.createElement("div", {
    className: "firstColl w-100"
  }, hasAction && /* @__PURE__ */ React.createElement("div", {
    onClick: () => onClick(),
    className: itemClss
  }, /* @__PURE__ */ React.createElement("i", {
    className: icon
  })), /* @__PURE__ */ React.createElement("p", {
    className: "name-fc"
  }, text));
};
DetailCol.defaultProps = {
  text: "",
  icon: "",
  hasAction: true,
  onClick: () => {
  }
};

const MyCustomFormat = ({ prefix, value, displayType, thousandSeparator, className }) => {
  let itemClss = classnames(className);
  return /* @__PURE__ */ React.createElement(NumberFormat, {
    value,
    prefix,
    className: itemClss,
    displayType,
    thousandSeparator
  });
};
MyCustomFormat.defaultProps = {
  value: 0,
  prefix: "Q",
  displayType: "text",
  thousandSeparator: true
};

const NumberRange = ({ start, end, className, barClass, format }) => {
  let progressBarClss = classnames("progressBar", className);
  let barClss = classnames("bar", barClass);
  const getPercentage = () => {
    return `${start / end * 100}%`;
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: progressBarClss
  }, /* @__PURE__ */ React.createElement("div", {
    className: barClss,
    style: { width: getPercentage() }
  }), /* @__PURE__ */ React.createElement("p", null, format, start), /* @__PURE__ */ React.createElement("p", null, format, end));
};

const GraphEdit = ({ className, type, options, series, height, width }) => /* @__PURE__ */ React.createElement("div", {
  className
}, /* @__PURE__ */ React.createElement(Chart, {
  type,
  width,
  height,
  series,
  options
}));

const useOutsideAlerter = (initialValue) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(initialValue);
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target))
      setVisible(false);
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref]);
  return { visible, setVisible, ref };
};

const StatusEdit = ({ id, label, value, className, onEditValue, nameColumn, type, dataSelect, editable }) => {
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [valueE, setvalueE] = useState(label);
  const [data, setData] = useState([]);
  let itemClss = classnames("secondColl", className, {
    "red": value == 0,
    "green": value == 1,
    "orange": value == 2
  });
  useEffect(() => {
    if (data.length > 0) {
      onEditValue(data);
      setData([]);
    }
  }, [visible]);
  const editData = (valor) => {
    setvalueE(valor);
    let dataAdd = {
      id,
      column: nameColumn,
      value: valor
    };
    setData([dataAdd]);
  };
  const item = () => {
    if (type == "text") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("input", {
        onChange: (e) => editData(e.target.value),
        type: "text",
        value: valueE
      }));
    }
    if (type == "select") {
      let result = [];
      if (dataSelect) {
        result = dataSelect.filter((item2, index) => {
          return dataSelect.indexOf(item2) === index;
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => editData(e.target.value)
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion:"), result.map((item2, idx) => /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: item2,
        key: idx
      }, item2))));
    }
  };
  const optionsView = () => {
    if (editable) {
      setVisible(true);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    onDoubleClick: () => optionsView()
  }, visible ? /* @__PURE__ */ React.createElement("div", {
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: itemClss
  }, valueE)));
};

const DateRangeEdit = ({ start, end, className, barClass, format, id, nameColumn, onEditValue, type, dataSelect }) => {
  let progressBarClss = classnames("progressBar", className);
  let barClss = classnames("bar", barClass);
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [data, setData] = useState([]);
  const [dateStart, setDateStart] = useState(start);
  const [dateEnd, setDateEnd] = useState(end);
  const [dateStartError, setdateStartError] = useState(false);
  const [dateEndError, setdateEndError] = useState(false);
  useEffect(() => {
    if (data.length > 0 && dateEndError == false && dateStartError == false) {
      onEditValue(data);
      setData([]);
    }
    if (dateEndError == true) {
      setdateEndError(false);
      setDateEnd(end);
    }
    if (dateStartError == true) {
      setDateStart(start);
      setdateStartError(false);
    }
  }, [visible]);
  const getPercentage = () => {
    const today = new Date();
    if (today < dateStart) {
      return "0%";
    } else {
      const spent = Math.round(
        (today.getTime() - dateStart.getTime()) / (1e3 * 60 * 60 * 24)
      );
      const total = Math.round(
        (dateEnd.getTime() - dateStart.getTime()) / (1e3 * 60 * 60 * 24) + 1
      );
      return `${spent / total * 100}%`;
    }
  };
  const cambioFecha = (date, tipo, format2) => {
    let timeZone = "";
    if (format2) {
      timeZone = dateFormat(date, "yyyy-dd-mm") + "T00:00:00";
    } else {
      timeZone = date + "T00:00:00";
    }
    let dataAdd = [];
    let dateSelected = new Date(timeZone);
    if (tipo == "start") {
      setDateStart(dateSelected);
      if (dateSelected <= dateEnd) {
        setdateStartError(false);
        let dataStart = {
          id,
          column: nameColumn,
          start: dateSelected,
          end: dateEnd
        };
        if (dateEnd >= dateSelected) {
          setdateEndError(false);
        }
        dataAdd.push(dataStart);
      } else {
        setdateStartError(true);
      }
    }
    if (tipo == "end") {
      setDateEnd(dateSelected);
      if (dateSelected >= dateStart) {
        setdateEndError(false);
        let dataEnd = {
          id,
          column: nameColumn,
          start: dateStart,
          end: dateSelected
        };
        dataAdd.push(dataEnd);
        if (dateStart <= dateSelected) {
          setdateStartError(false);
        }
      } else {
        setdateEndError(true);
      }
    }
    if (dataAdd.length > 0) {
      setData(dataAdd);
    }
  };
  const item = () => {
    if (type == "text") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fecha Inicial:"), /* @__PURE__ */ React.createElement("input", {
        type: "date",
        value: dateFormat(dateStart, "yyyy-mm-dd"),
        onChange: (e) => cambioFecha(e.target.value, "start")
      }), dateStartError && /* @__PURE__ */ React.createElement("label", {
        style: { fontSize: "10px" }
      }, "No puede ser mayor que la fecha final")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fecha final:"), /* @__PURE__ */ React.createElement("input", {
        type: "date",
        value: dateFormat(dateEnd, "yyyy-mm-dd"),
        onChange: (e) => cambioFecha(e.target.value, "end")
      }), dateEndError && /* @__PURE__ */ React.createElement("label", {
        style: { fontSize: "10px" }
      }, "No puede ser menor que la fecha inicial")));
    }
    if (type == "select") {
      let dataStart = [];
      let dataEnd = [];
      if (dataSelect) {
        dataSelect.forEach((el) => {
          if (el.start) {
            dataStart.push(dateFormat(el.start, "mm-dd-yyyy"));
          }
          if (el.end) {
            dataEnd.push(dateFormat(el.end, "mm-dd-yyyy"));
          }
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fecha inicial:"), /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => cambioFecha(e.target.value, "start", true)
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion"), dataStart.map(
        (data2, idx) => /* @__PURE__ */ React.createElement("option", {
          className: "option-options",
          key: idx,
          value: data2
        }, data2)
      )), dateStartError && /* @__PURE__ */ React.createElement("label", {
        className: "error-start",
        style: { fontSize: "10px" }
      }, "No puede ser mayor que la fecha final")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fecha final:"), /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => cambioFecha(e.target.value, "end", true)
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion:"), dataEnd.map((ele, idx) => /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        key: idx,
        value: ele
      }, ele))), dateEndError && /* @__PURE__ */ React.createElement("label", {
        className: "error-end",
        style: { fontSize: "10px" }
      }, "No puede ser menor que la fecha inicial")));
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: progressBarClss,
    onDoubleClick: () => setVisible(true)
  }, /* @__PURE__ */ React.createElement("div", {
    className: barClss,
    style: { width: getPercentage() }
  }), /* @__PURE__ */ React.createElement("p", null, dateFormat(start, format)), /* @__PURE__ */ React.createElement("p", null, dateFormat(end, format))));
};

const DetailColEdit = ({ text, className, icon, hasAction, onClick, id, nameColumn, onEditValue, type, dataSelect }) => {
  let itemClss = classnames(className);
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [texto, setTexto] = useState(text);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (data.length > 0) {
      onEditValue(data);
      setData([]);
    }
  }, [visible]);
  const actualizarTexto = (value) => {
    setTexto(value);
    let actText = {
      id,
      value,
      column: nameColumn
    };
    setData([actText]);
  };
  const item = () => {
    if (type == "text") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("input", {
        className: "name-fc",
        type: "text",
        onChange: (e) => actualizarTexto(e.target.value),
        value: texto
      }));
    }
    if (type == "select") {
      let result = [];
      if (dataSelect) {
        result = dataSelect.filter((item2, index) => {
          return dataSelect.indexOf(item2) === index;
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => actualizarTexto(e.target.value)
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Seleccina una opcion:"), result.map(
        (data2, idx) => /* @__PURE__ */ React.createElement("option", {
          className: "option-options",
          key: idx,
          value: data2
        }, data2)
      )));
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    className: "firstColl w-100",
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: "firstColl w-100",
    onDoubleClick: () => setVisible(true)
  }, hasAction && /* @__PURE__ */ React.createElement("div", {
    onClick: () => onClick(),
    className: itemClss
  }, /* @__PURE__ */ React.createElement("i", {
    className: icon
  })), /* @__PURE__ */ React.createElement("p", {
    className: "name-fc"
  }, texto)));
};
DetailColEdit.defaultProps = {
  text: "",
  icon: "",
  hasAction: true,
  onClick: () => {
  }
};

const MyCustomFormatEdit = ({ prefix, value, displayType, thousandSeparator, className, onEditValue, id, nameColumn, tipo, dataSelect, editable }) => {
  let itemClss = classnames(className);
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [data, setData] = useState([]);
  const [valueStart, setValueStart] = useState(value);
  useEffect(() => {
    if (data.length > 0) {
      onEditValue(data).then(() => {
        setValueStart(value);
      });
      setData([]);
    }
  }, [visible]);
  const updateNumber = (number) => {
    if (number !== 0) {
      setValueStart(number);
      let datos = {
        column: nameColumn,
        id,
        value: number
      };
      setData([datos]);
    } else {
      setValueStart("");
      let datos = {
        column: nameColumn,
        id,
        value: "0"
      };
      setData([datos]);
    }
  };
  const item = () => {
    if (tipo == "text") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NumberFormat, {
        onValueChange: (e) => updateNumber(Number(e.value)),
        value: valueStart,
        prefix,
        className: itemClss,
        displayType: "input",
        thousandSeparator
      }));
    }
    if (tipo == "select") {
      let result = [];
      if (dataSelect) {
        result = dataSelect.filter((item2, index) => {
          return dataSelect.indexOf(item2) === index;
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => updateNumber(Number(e.target.value))
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion:"), result.map((item2, idx) => /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: item2,
        key: idx
      }, item2))));
    }
  };
  const optionsView = () => {
    if (editable) {
      setVisible(true);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    onDoubleClick: () => optionsView()
  }, /* @__PURE__ */ React.createElement(NumberFormat, {
    value,
    prefix,
    className: itemClss,
    displayType,
    thousandSeparator
  })));
};
MyCustomFormatEdit.defaultProps = {
  value: 0,
  prefix: "Q",
  displayType: "text",
  thousandSeparator: true
};

const NumberRangeEdit = ({ start, editable, end, className, barClass, format, onEditValue, nameColumn, id, prefix, type, dataSelect }) => {
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [valueStart, setValueStart] = useState(start);
  const [data, setData] = useState([]);
  const [valueEnd, setValueEnd] = useState(end);
  const [errorEnd, setErrorEnd] = useState(false);
  const [errorStart, setErrorStart] = useState(false);
  let progressBarClss = classnames("progressBar", className);
  let barClss = classnames("bar", barClass);
  useEffect(() => {
    if (data.length > 0 && errorEnd == false && errorStart == false) {
      onEditValue(data);
      setData([]);
    }
    if (errorEnd == true) {
      setValueEnd(end);
      setErrorEnd(false);
    }
    if (errorStart == true) {
      setValueStart(start);
      setErrorStart(false);
    }
  }, [visible]);
  const getPercentage = () => {
    return `${valueStart / valueEnd * 100}%`;
  };
  const updateStart = (valorStart) => {
    setValueStart(Number(valorStart));
    if (valorStart <= valueEnd) {
      setValueStart(Number(valorStart));
      setErrorStart(false);
      let dataAdd = {
        id,
        column: nameColumn,
        start: valorStart,
        end: valueEnd
      };
      setData([dataAdd]);
      if (valueEnd >= valorStart) {
        setErrorEnd(false);
      }
    } else {
      setErrorStart(true);
    }
    if (valorStart == 0) {
      setValueStart("");
    }
  };
  const updateEnd = (valorEnd) => {
    setValueEnd(valorEnd);
    if (valorEnd >= valueStart) {
      setValueEnd(Number(valorEnd));
      setErrorEnd(false);
      let dataAdd = {
        id,
        column: nameColumn,
        start: valueStart,
        end: valorEnd
      };
      setData([dataAdd]);
      if (valueStart <= valorEnd) {
        setErrorStart(false);
      }
    } else {
      setErrorEnd(true);
    }
    if (valorEnd == 0) {
      setValueEnd("");
    }
  };
  const valueStar = (inputObj) => {
    const { value } = inputObj;
    if (value <= valueEnd) {
      setErrorStart(false);
      return true;
    }
    setErrorStart(true);
    return false;
  };
  const optionsView = () => {
    if (editable) {
      setVisible(true);
    }
  };
  const item = () => {
    if (type == "select") {
      let dataStart = [];
      let dataEnd = [];
      if (dataSelect) {
        dataSelect.map((el) => {
          if (el.start) {
            dataStart.push(el.start);
          }
          if (el.end) {
            dataEnd.push(el.end);
          }
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Valor inicial:"), /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => updateStart(Number(e.target.value))
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion"), dataStart.map(
        (data2, idx) => /* @__PURE__ */ React.createElement("option", {
          className: "option-options",
          key: idx,
          value: data2
        }, data2)
      )), errorStart && /* @__PURE__ */ React.createElement("label", {
        className: "error-start",
        style: { fontSize: "10px" }
      }, "No puede ser mayor que el monto final")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Valor final:"), /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => updateEnd(Number(e.target.value))
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion:"), dataEnd.map((ele, idx) => /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        key: idx,
        value: ele
      }, ele))), errorEnd && /* @__PURE__ */ React.createElement("label", {
        className: "error-end",
        style: { fontSize: "10px" }
      }, "No puede ser menor que el monto inicial")));
    }
    if (type == "text") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Valor inicial:"), /* @__PURE__ */ React.createElement(NumberFormat, {
        displayType: "input",
        prefix,
        value: valueStart,
        isAllowed: valueStar,
        thousandSeparator: true,
        onValueChange: (e) => updateStart(Number(e.value))
      }), errorStart && /* @__PURE__ */ React.createElement("label", {
        style: { fontSize: "10px" }
      }, "No puede ser mayor que el monto final")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Valor final:"), /* @__PURE__ */ React.createElement(NumberFormat, {
        displayType: "input",
        value: valueEnd,
        prefix,
        thousandSeparator: true,
        onValueChange: (e) => updateEnd(Number(e.value))
      }), errorEnd && /* @__PURE__ */ React.createElement("label", {
        style: { fontSize: "10px" }
      }, "No puede ser menor que el monto inicial")));
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    onDoubleClick: () => optionsView()
  }, visible ? /* @__PURE__ */ React.createElement("div", {
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: progressBarClss
  }, /* @__PURE__ */ React.createElement("div", {
    className: barClss,
    style: { width: getPercentage() }
  }), /* @__PURE__ */ React.createElement("p", null, format, valueStart), /* @__PURE__ */ React.createElement("p", null, format, valueEnd))));
};

const SimpleText = ({ value, id, onEditValue, editable, nameColumn, type, dataSelect, editCell }) => {
  const [valueE, setvalueE] = useState(value);
  const [data, setData] = useState([]);
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [dataOptions, setDataOptions] = useState([]);
  useEffect(() => {
    if (data.length > 0) {
      onEditValue(data).then(() => {
        setvalueE(value);
      });
      setData([]);
    }
  }, [visible]);
  useEffect(() => {
    if (dataSelect) {
      setDataOptions(dataSelect);
    }
  }, [dataSelect]);
  const editData = (valor) => {
    setvalueE(valor);
    let dataAdd = {
      id,
      column: nameColumn,
      value: valor
    };
    setData([dataAdd]);
  };
  const item = () => {
    if (type == "select") {
      let result = [];
      if (dataSelect) {
        result = dataOptions.filter((item2, index) => {
          return dataOptions.indexOf(item2) === index;
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("select", {
        className: "option-select",
        defaultValue: "DEFAULT",
        onChange: (e) => editData(e.target.value)
      }, /* @__PURE__ */ React.createElement("option", {
        className: "option-options",
        value: "DEFAULT",
        disabled: true
      }, "Selecciona una opcion:"), result.map(
        (data2, idx) => /* @__PURE__ */ React.createElement("option", {
          className: "option-options",
          key: idx,
          value: data2
        }, data2)
      )));
    }
    if (type == "text") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("input", {
        className: "name-fc",
        type: "text",
        onChange: (e) => editData(e.target.value),
        value: valueE
      }));
    }
  };
  const optionsView = () => {
    if (editable) {
      setVisible(true);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    onDoubleClick: () => optionsView()
  }, visible ? /* @__PURE__ */ React.createElement("div", {
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: editCell ? "alerta texto" : "texto",
    style: { width: "100px" }
  }, /* @__PURE__ */ React.createElement("p", {
    className: "name-text"
  }, value))));
};

const defaultText = "Selecciona una opcion:";
const OptionsSelectedEdit = ({ id, onEditValue, nameColumn, value, data, editable, textSelect, editCell }) => {
  const [valueE, setvalueE] = useState(value);
  const [dataEnv, setDataEnv] = useState([]);
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  useEffect(() => {
    if (dataEnv.length > 0) {
      onEditValue(dataEnv);
      setDataEnv([]);
    }
  }, [visible]);
  const editData = (valor) => {
    setvalueE(valor);
    let dataAdd = {
      id,
      column: nameColumn,
      value: valor
    };
    setDataEnv([dataAdd]);
  };
  let result = data.filter((item, index) => {
    return data.indexOf(item) === index;
  });
  const optionsView = () => {
    if (editable) {
      setVisible(true);
    }
  };
  let texto = textSelect ? textSelect : defaultText;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    ref
  }, /* @__PURE__ */ React.createElement("select", {
    className: "option-select",
    defaultValue: "DEFAULT",
    onChange: (e) => editData(e.target.value)
  }, /* @__PURE__ */ React.createElement("option", {
    className: "option-options",
    value: "DEFAULT",
    disabled: true
  }, texto), result.map(
    (data2, idx) => /* @__PURE__ */ React.createElement("option", {
      className: "option-options",
      key: idx,
      value: data2
    }, data2)
  ))) : /* @__PURE__ */ React.createElement("div", {
    className: editCell ? "alerta" : "",
    onDoubleClick: () => optionsView()
  }, /* @__PURE__ */ React.createElement("p", null, value)));
};

function Select({ multiple, value, onChange, options, styles }) {
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const containerRef = useRef(null);
  function clearOptions() {
    multiple ? onChange([]) : onChange(void 0);
  }
  function selectOption(option) {
    if (multiple) {
      let valores = value.map((ele) => ele.value);
      if (valores.includes(option.value)) {
        onChange(value.filter((o) => o.value !== option.value));
      } else {
        onChange([...value, option]);
      }
    } else {
      if (option !== value)
        onChange(option);
    }
  }
  function isOptionSelected(option) {
    return multiple ? value.includes(option) : option === value;
  }
  useEffect(() => {
    if (isOpen)
      setHighlightedIndex(0);
  }, [isOpen]);
  useEffect(() => {
    const handler = (e) => {
      if (e.target != containerRef.current)
        return;
      switch (e.code) {
        case "Enter":
        case "Space":
          setIsOpen((prev) => !prev);
          if (isOpen)
            selectOption(options[highlightedIndex]);
          break;
        case "ArrowUp":
        case "ArrowDown": {
          if (!isOpen) {
            setIsOpen(true);
            break;
          }
          const newValue = highlightedIndex + (e.code === "ArrowDown" ? 1 : -1);
          if (newValue >= 0 && newValue < options.length) {
            setHighlightedIndex(newValue);
          }
          break;
        }
        case "Escape":
          setIsOpen(false);
          break;
      }
    };
    if (containerRef.current) {
      containerRef.current.addEventListener("keydown", handler);
    }
    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener("keydown", handler);
      }
    };
  }, [isOpen, highlightedIndex, options]);
  return /* @__PURE__ */ React.createElement("div", {
    ref: containerRef,
    onBlur: () => setIsOpen(false),
    onClick: () => setIsOpen((prev) => !prev),
    tabIndex: 0,
    className: styles.containerSelect
  }, /* @__PURE__ */ React.createElement("span", {
    className: styles.valueSelectEdit
  }, multiple ? value.map((v) => /* @__PURE__ */ React.createElement("button", {
    key: v.value,
    onClick: (e) => {
      e.stopPropagation();
      selectOption(v);
    },
    className: styles.optionBadgeSelect
  }, v.label, /* @__PURE__ */ React.createElement("span", {
    className: styles.removeBtnSelect
  }, "\xD7"))) : value ? value.label : ""), /* @__PURE__ */ React.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      clearOptions();
    },
    className: styles.clearBtnSelect
  }, "\xD7"), /* @__PURE__ */ React.createElement("div", {
    className: styles.dividerSelect
  }), /* @__PURE__ */ React.createElement("div", {
    className: styles.caretSelect
  }), /* @__PURE__ */ React.createElement("ul", {
    className: `${styles.options} ${isOpen ? styles.show : ""}`
  }, options.map((option, index) => /* @__PURE__ */ React.createElement("li", {
    onClick: (e) => {
      e.stopPropagation();
      selectOption(option);
      setIsOpen(false);
    },
    onMouseEnter: () => setHighlightedIndex(index),
    key: option.value,
    className: `${styles.option} ${isOptionSelected(option) ? styles.selected : ""} ${index === highlightedIndex ? styles.highlighted : ""}`
  }, option.label))));
}

const OptionNewEdit = ({ multiple, value, onEditValue, options, text, edit, styles, id, nameColumn, optionalValue }) => {
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [data, setData] = useState([]);
  const [valueStart, setValueStart] = useState(value);
  useEffect(() => {
    if (data.length !== 0) {
      onEditValue(data);
      setValueStart(value);
    }
  }, [visible]);
  const changeView = () => {
    if (edit)
      setVisible(true);
  };
  const changeOptions = (value2) => {
    let body = {
      column: nameColumn,
      id,
      optionsSelect: value2,
      value: optionalValue ? optionalValue : ""
    };
    setValueStart(value2);
    setData([body]);
  };
  const item = () => {
    if (multiple) {
      return /* @__PURE__ */ React.createElement(Select, {
        multiple: true,
        options,
        value: valueStart,
        onChange: changeOptions,
        styles
      });
    } else {
      return /* @__PURE__ */ React.createElement(Select, {
        styles,
        options,
        value: valueStart,
        onChange: changeOptions
      });
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    ref,
    style: { position: "relative", zIndex: "999" }
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: "optionColSelect",
    onDoubleClick: () => changeView()
  }, /* @__PURE__ */ React.createElement("span", null, text)));
};

const DateRangeEditFormat = ({
  start,
  end,
  className,
  barClass,
  format,
  id,
  nameColumn,
  onEditValue,
  dataSelect
}) => {
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [dateStart, setDateStart] = useState(new Date());
  const [dateEnd, setDateEnd] = useState(new Date());
  const [dateStartError, setdateStartError] = useState(false);
  const [dateEndError, setdateEndError] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (end !== null) {
      setDateEnd(end);
    }
    if (start !== null) {
      setDateStart(start);
    }
  }, [start, end]);
  useEffect(() => {
    if (data.length > 0 && dateEndError == false && dateStartError == false) {
      onEditValue(data);
      setData([]);
    }
    if (dateEndError == true) {
      setdateEndError(false);
      setDateEnd(end);
    }
    if (dateStartError == true) {
      setDateStart(start);
      setdateStartError(false);
    }
  }, [visible]);
  let progressBarClss = classnames("progressBar", className);
  let barClss = classnames("bar", barClass);
  const getPercentage = () => {
    const today = new Date();
    if (today < dateStart) {
      return "0%";
    } else if (dateEnd === null || dateStart === null) {
      return "0%";
    } else {
      const spent = Math.round(
        (today.getTime() - dateStart.getTime()) / (1e3 * 60 * 60 * 24)
      );
      const total = Math.round(
        (dateEnd.getTime() - dateStart.getTime()) / (1e3 * 60 * 60 * 24) + 1
      );
      return `${spent / total * 100}%`;
    }
  };
  const cambioFecha = (date, tipo) => {
    let dataAdd = [];
    let fechaEnv = new Date(date + "T00:00:00");
    if (isNaN(fechaEnv.getTime()))
      return;
    if (tipo === "start") {
      setDateStart(fechaEnv);
      if (fechaEnv <= dateEnd) {
        setdateStartError(false);
        let dataStart = {
          id,
          column: nameColumn,
          start: fechaEnv,
          end: dateEnd
        };
        if (dateEnd >= fechaEnv) {
          setdateEndError(false);
        }
        dataAdd.push(dataStart);
      } else {
        setdateStartError(true);
      }
    } else {
      setDateEnd(fechaEnv);
      if (fechaEnv >= dateStart) {
        setdateEndError(false);
        let dataEnd = {
          id,
          column: nameColumn,
          start: dateStart,
          end: fechaEnv
        };
        dataAdd.push(dataEnd);
        if (dateStart <= fechaEnv) {
          setdateStartError(false);
        }
      } else {
        setdateEndError(true);
      }
    }
    if (dataAdd.length > 0) {
      setData(dataAdd);
    }
  };
  const item = () => {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fecha Inicial:"), /* @__PURE__ */ React.createElement("input", {
      type: "date",
      value: dateStart.toISOString().slice(0, 10),
      onChange: (e) => cambioFecha(e.target.value, "start")
    }), dateStartError && /* @__PURE__ */ React.createElement("label", {
      style: { fontSize: "10px" }
    }, "No puede ser mayor que la fecha final")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fecha final:"), /* @__PURE__ */ React.createElement("input", {
      type: "date",
      value: dateEnd.toISOString().slice(0, 10),
      onChange: (e) => cambioFecha(e.target.value, "end")
    }), dateEndError && /* @__PURE__ */ React.createElement("label", {
      style: { fontSize: "10px" }
    }, "No puede ser menor que la fecha inicial"))));
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      setVisible(false);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    onKeyDown: handleEnter,
    ref
  }, item()) : /* @__PURE__ */ React.createElement("div", {
    className: progressBarClss,
    onDoubleClick: () => setVisible(true)
  }, /* @__PURE__ */ React.createElement("div", {
    className: barClss,
    style: { width: getPercentage() }
  }), start !== null && /* @__PURE__ */ React.createElement("p", null, dateFormat(start, format)), end !== null && /* @__PURE__ */ React.createElement("p", null, dateFormat(end, format)), !start && !end && /* @__PURE__ */ React.createElement("span", null, "Seleccione fecha")));
};

const { Option } = Select$1;
const EditAnt = ({
  edit,
  style,
  onEditValue,
  placeholder,
  options,
  defaultValue,
  nameColumn,
  id,
  optionalValue,
  texto
}) => {
  const { visible, setVisible, ref } = useOutsideAlerter(false);
  const [data, setData] = useState([]);
  const [valueStart, setValueStart] = useState(defaultValue);
  const [opciones, setOpciones] = useState([]);
  useEffect(() => {
    if (options) {
      let opt = [];
      options.forEach((element) => {
        opt.push(/* @__PURE__ */ React.createElement(Option, {
          key: element
        }, element, " "));
      });
      setOpciones([...opt]);
    }
  }, [options]);
  useEffect(() => {
    if (data.length !== 0) {
      onEditValue(data);
      setData([]);
    }
  }, [visible]);
  const changeView = () => {
    if (edit)
      setVisible(true);
  };
  const changeOptions = (value) => {
    let body = {
      column: nameColumn,
      id,
      optionsSelect: value,
      value: optionalValue ? optionalValue : ""
    };
    setValueStart(value);
    setData([body]);
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      setVisible(false);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible ? /* @__PURE__ */ React.createElement("div", {
    onKeyDown: handleEnter
  }, /* @__PURE__ */ React.createElement(Select$1, {
    onBlur: () => setVisible(false),
    mode: "multiple",
    style,
    placeholder,
    value: valueStart,
    onChange: (e) => changeOptions(e)
  }, opciones)) : /* @__PURE__ */ React.createElement("div", {
    onDoubleClick: () => changeView()
  }, /* @__PURE__ */ React.createElement("span", null, texto)));
};

const tableWrapper = "_tableWrapper_3uitz_1";
const buttonWrapper = "_buttonWrapper_3uitz_7";
var styles = {
	tableWrapper: tableWrapper,
	buttonWrapper: buttonWrapper
};

function ReactDataTable(props) {
  const [expanded, setExpanded] = useState(true);
  const customStyles = {
    rows: {
      style: {
        display: expanded ? "flex" : "none"
      }
    }
  };
  return props.expandable ? /* @__PURE__ */ React.createElement("div", {
    className: styles.tableWrapper
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.buttonWrapper
  }, /* @__PURE__ */ React.createElement("button", {
    onClick: () => setExpanded(!expanded),
    className: "btn-show-table"
  }, expanded ? /* @__PURE__ */ React.createElement(ArrowDropDownIcon, null) : /* @__PURE__ */ React.createElement(ArrowRightIcon, null))), /* @__PURE__ */ React.createElement(DataTable, {
    ...props,
    noHeader: true,
    pagination: false,
    customStyles
  })) : /* @__PURE__ */ React.createElement(DataTable, {
    ...props
  });
}
ReactDataTable.defaultProps = {
  expandable: false
};

export { DateRange, DateRangeEdit, DateRangeEditFormat, DetailCol, DetailColEdit, EditAnt, Graph, GraphEdit, MyCustomFormat as NumberFormat, MyCustomFormatEdit as NumberFormatEdit, NumberRange, NumberRangeEdit, OptionNewEdit, OptionsSelectedEdit, SimpleText, Status, StatusEdit, ReactDataTable as default };
//# sourceMappingURL=index.es.js.map
